export const getCreateCreditTokenUrl = (baseUrl, userType) => {
  const endpoint =
    userType === "corporate"
      ? "createCreditTokenForCorporate"
      : "createCreditToken";

  return `${baseUrl}/api/webhook/${endpoint}`;
};
